import React from 'react';
import { isForbidden, isNotFound } from '@tribeplatform/gql-client';
import { PostStatus } from '@tribeplatform/gql-client/types';
import { PostCardLoading } from '@tribeplatform/react-components/LoadingStates';
import { Post } from '@tribeplatform/react-components/Post';
import { ReplyList } from '@tribeplatform/react-components/Reply';
import { useAuthMember, useNetwork, usePost, } from '@tribeplatform/react-sdk/hooks';
import { PostNotFound } from './PostNotFound.js';
export const PostBlock = ({ id }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { isModerator, data: authMember } = useAuthMember();
    const { data: network } = useNetwork();
    const { data: post, error: _error, isLoading, isFetched, } = usePost({
        variables: { id },
        fields: 'default',
        useQueryOptions: {
            refetchOnMount: 'always',
            retry: false,
            enabled: !!id,
        },
    });
    const error = _error;
    if (!post && !isLoading && error) {
        if (isNotFound(error) || isForbidden(error)) {
            return React.createElement(PostNotFound, null);
        }
    }
    if (post &&
        !isModerator &&
        (post === null || post === void 0 ? void 0 : post.status) !== PostStatus.PUBLISHED &&
        (authMember === null || authMember === void 0 ? void 0 : authMember.id) &&
        ((_b = (_a = post === null || post === void 0 ? void 0 : post.owner) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.id) !== (authMember === null || authMember === void 0 ? void 0 : authMember.id)) {
        return React.createElement(PostNotFound, null);
    }
    if (!post && !isFetched) {
        return React.createElement(PostCardLoading, null);
    }
    const validPostTypes = ((_d = (_c = network === null || network === void 0 ? void 0 : network.postTypes) === null || _c === void 0 ? void 0 : _c.find(postType => postType.id === (post === null || post === void 0 ? void 0 : post.postTypeId))) === null || _d === void 0 ? void 0 : _d.validReplyTypes) ||
        ((_e = post.postType) === null || _e === void 0 ? void 0 : _e.validReplyTypes) ||
        [];
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(Post, { replyBar: false, post: post, context: "post", collapsible: false }),
        ((validPostTypes === null || validPostTypes === void 0 ? void 0 : validPostTypes.length) > 0 || ((_g = (_f = post === null || post === void 0 ? void 0 : post.replies) === null || _f === void 0 ? void 0 : _f.nodes) === null || _g === void 0 ? void 0 : _g.length) > 0) && (React.createElement(ReplyList, { post: post }))));
};
//# sourceMappingURL=Block.js.map